import { DateTime } from "luxon";

export const TIME_ZONES = {
  AR: "America/Argentina/Buenos_Aires",
  CL: "America/Santiago",
};

const leftPad =
  (nb = 2) =>
  (value) =>
    value.toString().padStart(nb, "0");

const timeRegex = /^\d{2}:\d{2}$/;

const getTimeTokens = (value) => value.split(":").map((v) => parseInt(v, 10));

const formatTime = (zonedDate) =>
  `${leftPad()(zonedDate.hour)}:${leftPad()(zonedDate.minute)}`;

export const formatTimeTimezone = (country) => (value) => {
  if (!value) return "";

  const timeZone = TIME_ZONES[country];
  let zonedDate;

  if (value instanceof Date) {
    // Date input: treat as UTC then convert
    zonedDate = DateTime.fromJSDate(value, { zone: "utc" }).setZone(timeZone);
  } else if (timeRegex.test(value)) {
    // "HH:mm" string: parse tokens as UTC then convert
    const [hour, minute] = getTimeTokens(value);
    zonedDate = DateTime.utc()
      .set({ hour, minute, second: 0, millisecond: 0 })
      .setZone(timeZone ?? "utc");
  } else {
    // ISO string: parse as UTC then convert
    zonedDate = DateTime.fromISO(value, { zone: "utc" }).setZone(timeZone);
  }

  return zonedDate ? formatTime(zonedDate) : value;
};

export const parseTimeTimezone =
  (country, returnTimeOnly = false) =>
  (value) => {
    if (!value || !timeRegex.test(value)) return null;

    const [hour, minute] = getTimeTokens(value);
    const timeZone = TIME_ZONES[country];

    const dtInZone = DateTime.now()
      .setZone(timeZone ?? "utc")
      .set({ hour, minute, second: 0, millisecond: 0 });

    // Convert to UTC
    const dtUtc = dtInZone.toUTC();

    // Return either a Date or an "HH:mm" string
    if (returnTimeOnly) {
      return formatTime(dtUtc);
    }
    return dtUtc.toJSDate();
  };

export const parseTimeOnCreate = (value) => {
  if (!value || !timeRegex.test(value)) return null;

  const [hour, minute] = getTimeTokens(value);
  const today = new Date();
  today.setUTCHours(hour);
  today.setUTCMinutes(minute);
  return today;
};

export const formatTimeOnCreate = (value) => {
  if (!value) return "";

  const zonedDate =
    value instanceof Date
      ? DateTime.fromJSDate(value, { zone: "utc" })
      : DateTime.fromISO(value, { zone: "utc" });

  return timeRegex.test(value) ? value : formatTime(zonedDate);
};
